import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Loader2, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";

export const AutoBackupAlert = () => {
  const [health, setHealth] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/backup/auto/health").then((r) => setHealth(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!health || health.ok) return null;
  const retry = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/backup/auto/run", {}, { timeout: 0 });
      if (r.data.durum === "hazir") toast.success("Yedek alındı ve saklandı"); else toast.error(`Yedek yine alınamadı: ${r.data.hata || ""}`);
      load();
    } catch { toast.error("Yedek alınamadı"); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-[1600px] mx-auto px-6 pt-4" data-testid="auto-backup-alert">
      <div className="border border-red-300 bg-red-50 rounded-xl px-4 py-3 flex items-center gap-3 flex-wrap">
        <AlertTriangle size={16} className="text-red-600" />
        <div className="flex-1 min-w-[240px]">
          <div className="text-sm font-bold text-red-900">Otomatik haftalık yedekte sorun var</div>
          {health.issues.map((i) => (
            <div key={i.kod} className="text-xs text-red-800" data-testid={`auto-backup-alert-${i.kod}`}>{i.mesaj}</div>
          ))}
        </div>
        <button type="button" onClick={retry} disabled={busy} data-testid="auto-backup-alert-retry"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg text-xs font-semibold disabled:opacity-50">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />} Şimdi yeniden al
        </button>
      </div>
    </div>
  );
};
